var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33392 3.38071C5.11859 2.92671 6.02925 2.66671 6.99992 2.66671C9.94325 2.66671 12.3333 5.05671 12.3333 8.00004C12.3333 10.9434 9.94325 13.3334 6.99992 13.3334C4.05659 13.3334 1.66659 10.9434 1.66659 8.00004C1.66659 7.02937 1.92659 6.11871 2.38059 5.33404C2.56525 5.01537 2.45592 4.60737 2.13792 4.42337C1.81925 4.23871 1.41125 4.34737 1.22659 4.66604C0.658585 5.64671 0.333252 6.78604 0.333252 8.00004C0.333252 11.6794 3.32059 14.6667 6.99992 14.6667C10.6793 14.6667 13.6666 11.6794 13.6666 8.00004C13.6666 4.32071 10.6793 1.33337 6.99992 1.33337C5.78592 1.33337 4.64659 1.65871 3.66592 2.22671C3.34725 2.41137 3.23859 2.81937 3.42325 3.13804C3.60725 3.45604 4.01525 3.56537 4.33392 3.38071Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33325 6.06669V9.26669C5.33325 9.63469 5.63192 9.93336 5.99992 9.93336H8.66659C9.03459 9.93336 9.33325 9.63469 9.33325 9.26669C9.33325 8.89869 9.03459 8.60002 8.66659 8.60002H6.66659V6.06669C6.66659 5.69869 6.36792 5.40002 5.99992 5.40002C5.63192 5.40002 5.33325 5.69869 5.33325 6.06669Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61388 3.01872L4.47388 2.58805L4.90454 1.44805C5.03454 1.10338 4.86121 0.718717 4.51654 0.588717C4.17254 0.458717 3.78788 0.63205 3.65788 0.976717L2.99121 2.74072C2.86054 3.08472 3.03454 3.46938 3.37921 3.59938L5.14254 4.26605C5.48721 4.39605 5.87188 4.22272 6.00188 3.87805C6.13188 3.53405 5.95854 3.14938 5.61388 3.01872Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.37a056c4466e138b2c78a4f49b08f0b7.svg";
export { ForwardRef as ReactComponent };